/**
 * GSAP Fade In up Animation
 *
 * HOW TO USE:
 * Add the class "gsap-fade-in-up" to any HTML element to make it fade in from below
 * when it enters the viewport.
 *
 * EXAMPLE:
 * <div class="gsap-fade-in-up">This content will fade in from below</div>
 * <h2 class="gsap-fade-in-up">This heading will animate too</h2>
 *
 * ANIMATION DETAILS:
 * - Starts 30px below final position (y: 30)
 * - Fades from opacity 0 to 1
 * - Duration: 1 second
 * - Easing: power2.out (smooth deceleration)
 * - Triggers when element top reaches 99% of viewport height
 * - Plays once only (doesn't repeat on scroll)
 */

const fadeInup = document.querySelectorAll(".gsap-fade-in-up");
if (fadeInup.length) {
  gsap.utils.toArray(".gsap-fade-in-up").forEach((element) => {
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 99%",
        end: "bottom 10%",
        toggleActions: "play none none none",
      },
    });

    tl.from(element, {
      duration: 1,
      delay: 0.3,
      opacity: 0,
      y: -50,
      ease: "power2.out",
    });
  });
}
